<smr-booking-item
  [booking]="booking"
  *ngFor="let booking of bookingList"
  [routerLink]="['/BookingFormSummaryPage', booking.getId()]"
  (click)="onBookingView(booking)"
  [displayClientName]="false"
  
></smr-booking-item>

<salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

<salonmonster-tap-retry
  *ngIf="errorOccurredWhileLoadingBookings"
  (click)="loadBookings()"
></salonmonster-tap-retry>
